<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.project')"
    icon="res-billproject"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :hiddenKindTabs="['domain', 'project', 'project_tag']"
      :defaultProjectId="listRowData.tenant_id"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudprojectSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillProjectSidePage'
        default:
          return ''
      }
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || ''
      return { dateParam, dateMode }
    },
  },
}
</script>
